module.exports = __webpack_public_path__ + "img/phone-subscription.db75d63.png";